export const sx = {
    root:{
        padding:{
            xs:'5px 13px',
            lg:'5px 13px'
        }
    }
}